/**
 * P5.js インスタンス管理クラス
 *
 * 本モジュールは P5.js のインスタンスをシングルトンとして管理します。
 */
import type p5 from 'p5';

/**
 * P5.js インスタンスのシングルトン管理
 */
let p5Instance: p5 | null = null;

/**
 * P5インスタンスを設定
 * @param p - P5.jsインスタンス
 */
export function setP5Instance(p: p5): void {
    p5Instance = p;
}

/**
 * P5インスタンスを取得
 * @returns P5.jsインスタンス
 * @throws 初期化前に呼び出された場合エラー
 */
export function getP5(): p5 {
    if (!p5Instance) {
        throw new Error('P5.js instance not initialized. Call setP5Instance() first.');
    }
    return p5Instance;
}
